import { Flex, IllustratedMessage } from '@percent/lemonade';
import { Title, Text } from '@mantine/core';
import { useTranslation } from 'react-i18next';
import { Layout } from '@percent/grants-nomination-form/ui';

export const InvalidLink = () => {
  const { t } = useTranslation();

  return (
    <Layout>
      <Flex direction="column" align="center" gap={8} m="auto">
        <IllustratedMessage illustration="invalid-link" />
        <Title order={2} fz={24} fw={600} ta="center">
          {t('typography.invalidLinkTitle')}
        </Title>
        <Text fz={14} ta="center">
          {t('typography.invalidLinkDescription')}
        </Text>
      </Flex>
    </Layout>
  );
};
